export default __webpack_public_path__ + "static/media/jinsoo_crop_resize.15a1e01d.jpg";